import { useState } from 'react';
import { faqs } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100/80 py-14 md:py-16">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHeading
          eyebrow="FAQ"
          title="吃瓜前，你可能想问"
          desc="关于更新频率、内容来源与投稿方式，这里一次说清楚。"
        />

        <div className="grid gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqs.map((item, index) => {
                const open = openIndex === index;
                return (
                  <div
                    key={item.q}
                    className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? null : index)}
                      aria-expanded={open}
                      className="flex w-full items-center gap-4 px-5 py-4 text-left"
                    >
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-100 text-sm font-medium text-primary-700">
                        {index + 1}
                      </span>
                      <h3 className="flex-1 text-sm font-medium text-foreground-900 md:text-base">
                        {item.q}
                      </h3>
                      <i
                        className={`${
                          open ? 'ri-subtract-line' : 'ri-add-line'
                        } w-5 h-5 flex items-center justify-center text-lg text-foreground-500`}
                      />
                    </button>
                    {open && (
                      <div className="border-t border-background-200 px-5 py-4 pl-16">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-2xl border border-primary-200/70 bg-primary-50/70 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                <i className="ri-question-answer-line w-6 h-6 flex items-center justify-center text-2xl" />
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">
                还有别的问题？
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                如果你想知道的内容没在这里，可以直接写信给我们，通常一个工作日内回复。
              </p>
              <a
                href="mailto:hello@tangxin-chigua.example.com"
                className="mt-5 inline-flex whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                联系我们
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}